var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "arrow-left-a",
    d: "M13.076 3.076L7.283 8.869a1.6 1.6 0 000 2.262l5.793 5.793a.6.6 0 00.848-.848l-5.793-5.793a.4.4 0 010-.566l5.793-5.793a.6.6 0 00-.848-.848z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "arrow-left-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrow-left-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#5C5C5C",
    fillRule: "nonzero",
    xlinkHref: "#arrow-left-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    mask: "url(#arrow-left-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5-5h30v30H-5z"
  })))));
};
export default SvgArrowLeft;